module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-relay/~/babel-runtime/core-js/array/from.js
 ** module id = 260
 ** module chunks = 0
 **/